export default "__VITE_ASSET__BbQpZSvl__"